/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/11/2020
 */
import {Type} from "class-transformer";
import DbBaseObject from "@shared/DbBaseObject";
import ClientProfile from "@shared/Profile/ClientProfile";

export default class FunnelEntryItem extends DbBaseObject {

	columnId: string = null
	index: string = null

	@Type(() => ClientProfile)
	clientProfile: ClientProfile = null


	beforeSaveToDb(options) {
		super.beforeSaveToDb(options)
		console.log("beforeSaveToDb: this.clientProfile = ", this.clientProfile)
		this.clientProfile.beforeSaveToDb(options)
	}

}
